<ng-container *transloco="let t">
  <ng-container *ngIf="isMobile">
    <ng-container *ngIf="isAppMobile; then privateMenu; else publicMenu"></ng-container>
    <ng-template #privateMenu>
      <div class="mobile-nav border-1 border-primary surface-0" *ngIf="items$ | async as items">
        <ul class="list-none py-2 m-0 flex select-none">
          <ng-container *ngFor="let item of items">
            <li class="flex-1" *ngIf="item['private']">
              <a
                (click)="navigateAndClose('/dashboard/' + item.url)"
                [ngClass]="{ active: isActive('/dashboard/' + item.url) }"
                pRipple
                class="flex flex-column gap-2 px-2 py-2 align-items-center justify-content-center transition-colors transition-duration-150">
                <i class="pi + {{ item.icon }}"></i>
                <span class="white-space-nowrap text-sm">
                  {{ t('homepage.menuBottom.' + item.id) }}
                </span>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-template>
    <ng-template #publicMenu>
      <div class="mobile-nav-login border-1 border-primary surface-0 p-2 flex align-items-center">
        <p-button
          icon="pi pi-sign-in"
          class="w-full"
          styleClass="p-button-outline w-full"
          label="{{ t('homepage.menuBottom.registrati-o-accedi') }}"
          (click)="login()"></p-button>
      </div>
      <p-dialog [(visible)]="isVisible" appendTo="body" [modal]="true" [draggable]="false">
        <ng-template pTemplate="header">
          <div class="flex align-items-center"></div>
        </ng-template>
        <ng-template pTemplate="body">
          <app-login-signup (loginSuccess)="dialogService.hideDialog()"></app-login-signup>
        </ng-template>
      </p-dialog>
    </ng-template>
  </ng-container>
</ng-container>
